import { render } from "./CxFrameRateMonitor.vue?vue&type=template&id=298c34b9&scoped=true"
import script from "./CxFrameRateMonitor.vue?vue&type=script&lang=js"
export * from "./CxFrameRateMonitor.vue?vue&type=script&lang=js"

import "./CxFrameRateMonitor.vue?vue&type=style&index=0&id=298c34b9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298c34b9"]])

export default __exports__